(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 3269:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(3569);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
;// CONCATENATED MODULE: ./components/hooks/useForm.js

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useForm(initialValues) {
    var ref = (0,compat_module.useState)(initialValues), values = ref[0], setValues = ref[1];
    return [
        values,
        function(e) {
            setValues(_objectSpread({}, values, _defineProperty({}, e.target.name, e.target.value)));
        }, 
    ];
}

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./components/MessageBox.js

function MessageBox(param) {
    var type = param.type, message = param.message;
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "message-box message-box--".concat(type),
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
            className: "message-box__content",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                children: message
            })
        })
    }));
};

;// CONCATENATED MODULE: ./components/Form.js






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function Form(param) {
    var fields = param.fields, header = param.header, button = param.button, endpoint = param.endpoint;
    var ref = _slicedToArray(useForm({}), 2), values = ref[0], handleChange = ref[1];
    var ref1 = (0,compat_module.useState)({
        loading: false,
        success: false,
        error: null
    }), status = ref1[0], setStatus = ref1[1];
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setStatus({
                            loading: true,
                            success: false,
                            error: null
                        });
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return axios_default().post(endpoint, values);
                    case 5:
                        res = _ctx.sent;
                        if (res) {
                            setStatus({
                                loading: false,
                                success: true,
                                error: null,
                                message: res.data.message
                            });
                        }
                        if (res.headers.authorization) {
                            localStorage.setItem('Authorization', res.headers.authorization.split(' ')[1]);
                        }
                        if (res.headers.refresh) {
                            localStorage.setItem('Refresh', res.headers.refresh);
                        }
                        fields.map(function(field) {
                            return values[field.name] = '';
                        });
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](2);
                        setStatus({
                            loading: false,
                            success: false,
                            error: _ctx.t0.response.data
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    12
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
        className: "form__container",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("form", {
            onSubmit: handleSubmit,
            className: "form",
            children: [
                status.success && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MessageBox, {
                    type: "success",
                    message: status.message
                }),
                status.error && !status.error.fields && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(MessageBox, {
                    type: "error",
                    message: status.error.message
                }),
                header && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "form__header",
                    children: header
                }),
                fields.map(function(field) {
                    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: 'form__input',
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                                "aria-label": field.label,
                                "aria-required": field.required,
                                type: field.type,
                                name: field.name,
                                value: field.value ? field.value : values[field.name],
                                onChange: field.type === 'file' ? field.uploadFunction : handleChange,
                                autoComplete: field.name === 'password' || field.name === 'confirmPassword' ? 'new-password' : 'off',
                                autoCorrect: field.name === 'message' ? 'on' : 'off'
                            }),
                            status.error && status.error.fields && status.error.fields.includes(field.name) && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("label", {
                                htmlFor: field.name,
                                className: "error__container",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "error__message",
                                    children: status.error.message
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("label", {
                                htmlFor: field.name,
                                className: "label__container",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                    className: "label__name",
                                    children: field.label
                                })
                            })
                        ]
                    }, field.name));
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                    disabled: status.loading,
                    type: "submit",
                    children: status.loading ? 'loading' : button
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
;// CONCATENATED MODULE: ./pages/contact.js



function contact() {
    var fields = [
        {
            name: 'name',
            label: 'Name',
            type: 'text',
            required: true,
            placeholder: 'Enter your name'
        },
        {
            name: 'email',
            label: 'Email',
            type: 'email',
            required: true,
            placeholder: 'Enter your email'
        },
        {
            name: 'phone',
            label: 'Phone (optional)',
            type: 'tel',
            placeholder: 'Enter your phone number'
        },
        {
            name: 'message',
            label: 'Message',
            type: 'textarea',
            required: true,
            placeholder: 'Enter your message'
        }, 
    ];
    var header = /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                children: "Contact Me!"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                children: " Want to work with me / hire me? Feedback about the site? Reach Out!"
            })
        ]
    });
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: "page__container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("title", {
                    children: "Contact Me"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Form, {
                fields: fields,
                header: header,
                button: 'Send',
                endpoint: '/api/contact'
            })
        ]
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,9774,2888,179], function() { return __webpack_exec__(3269); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);